import {Component, Input, OnChanges, OnInit, SimpleChange} from "@angular/core";
import {ExtOperator} from "../../../../../../models/ext-operator";
import {BaseError} from "../../../../base-error";

@Component({ template: '' })
export class BaseFieldDeterminantComponent extends BaseError implements OnInit, OnChanges {
  public operators: string[];
  @Input() public isTargetComponent: boolean;
  @Input() public operator: any;

  public ngOnInit(): void {
    if (this.isTargetComponent) {
      this.operators.push(ExtOperator.IS_VALID);
      this.operators.push(ExtOperator.IS_NOT_VALID);
    }
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if ((changes.isTargetComponent || changes.operators) && this.operators) {
      this.checkOperators();
    }
  }

  protected checkOperators() {
    if (this.isTargetComponent) {
      if (!this.operators.includes(ExtOperator.IS_VALID)) {
        this.operators.push(ExtOperator.IS_VALID);
        this.operators.push(ExtOperator.IS_NOT_VALID);
      }
    } else {
      let index = this.operators.indexOf(ExtOperator.IS_VALID);
      // @ts-ignore
      if (this.operator === ExtOperator.IS_VALID) {
        this.operator = null;
      }
      if (index !== -1) {
        this.operators.splice(index, 1);
      }
      index = this.operators.indexOf(ExtOperator.IS_NOT_VALID);
      // @ts-ignore
      if (this.operator === ExtOperator.IS_NOT_VALID) {
        this.operator = null;
      }
      if (index !== -1) {
        this.operators.splice(index, 1);
      }
    }
  }

  public isOperatorIsValid() {
    return ExtOperator.IS_VALID === this.operator || this.operator === ExtOperator.IS_NOT_VALID;
  }
}
